module.exports = __webpack_public_path__ + "img/bg-cant-find@2x.c23580be.webp";